{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2018 - 2025                               }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDateTimePicker;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}

interface

uses
  Classes, Types,
  {$IFDEF FMXLIB}
  FMX.Types, FMX.DateTimeCtrls,
  {$ENDIF}
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCTypes, WEBLib.TMSFNCDatePicker,
  WEBLib.TMSFNCDigitalTimePicker, WEBLib.TMSFNCAnalogTimePicker, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCUtils, WEBLib.TMSFNCStyles;

  const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 2; // Release nr.
  BLD_VER = 1; // Build nr.

  //Version history
  //v1.0.0.0 : First Release
  //v1.0.1.0 : New : Property AllowNumericNullValue added
  //         : New : Method Clear added
  //         : Fixed : Issue with OnDateTimeSelected event
  //v1.0.1.1 : Fixed : Issue with incorrect time selection
  //v1.0.1.2 : Fixed : Issue with control color in disabled state
  //v1.0.1.3 : Fixed : Issue with OnDateTimeSelected event after dropdown close
  //v1.0.2.0 : New : Added property Native for FMX
  //v1.0.2.1 : Fixed : Issue with high DPI

type
  TTMSFNCDateTimePickerMode = (dtpmAnalog, dtpmDigital);

  TTMSFNCCustomDateTimePickerDateTimeChangedEvent = procedure(Sender: TObject; ADateTime: TDateTime) of object;

  TTMSFNCCustomDateTimePicker = class(TTMSFNCCustomControl, ITMSFNCStylesManager)
  private
    FDatePicker: TTMSFNCDatePicker;
    FDigitalTimePicker: TTMSFNCDigitalTimePicker;
    FOnDateTimeChanged: TTMSFNCCustomDateTimePickerDateTimeChangedEvent;
    FEditable: Boolean;
    FTimePickerMode: TTMSFNCDateTimePickerMode;
    FCloseOnSelection: Boolean;
    FAnalogTimePicker: TTMSFNCAnalogTimePicker;
    FAllowNumericNullValue: Boolean;
    {$IFDEF FMXLIB}
    FNative: Boolean;
    FDateEdit: TDateEdit;
    FTimeEdit: TTimeEdit;
    procedure SetNative(const Value: Boolean);
    {$ENDIF}
    procedure SetSelectedDateTime(const Value: TDateTime);
    procedure SetEditable(const Value: Boolean);
    procedure SetTimePickerMode(const Value: TTMSFNCDateTimePickerMode);
    procedure SetCloseOnSelection(const Value: Boolean);
    procedure SetAllowNumericNullValue(const Value: Boolean);
    function GetSelectedDateTime: TDateTime;
  protected
    procedure Loaded; override;
    {$IFDEF FMXLIB}
    procedure DateEditChanged(Sender: TObject);
    procedure TimeEditChanged(Sender: TObject);
    procedure SetEnabled(const Value: Boolean); override;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    procedure SetEnabled(Value: Boolean); override;
    {$ENDIF}
    procedure UpdateControlAfterResize; override;
    procedure SetAdaptToStyle(const Value: Boolean); override;
    procedure DateSelected(Sender: TObject; ADate: TDate);
    procedure TimeSelected(Sender: TObject; ATime: TTime);
    procedure DoDateTimeChanged(ADateTime: TDateTime); virtual;
    procedure ChangeMode(AMode: TTMSFNCDateTimePickerMode);
    function GetVersion: string; override;
    function GetSubComponentArray: TTMSFNCStylesManagerComponentArray;
    property AllowNumericNullValue: Boolean read FAllowNumericNullValue write SetAllowNumericNullValue default True;
    property Editable: Boolean read FEditable write SetEditable default False;
    property CloseOnSelection: Boolean read FCloseOnSelection write SetCloseOnSelection default True;
    property TimePickerMode: TTMSFNCDateTimePickerMode read FTimePickerMode write SetTimePickerMode default dtpmDigital;
    property SelectedDateTime: TDateTime read GetSelectedDateTime write SetSelectedDateTime;
    {$IFDEF FMXLIB}
    property Native: Boolean read FNative write SetNative default False;
    {$ENDIF}
    property OnDateTimeChanged: TTMSFNCCustomDateTimePickerDateTimeChangedEvent read FOnDateTimeChanged write FOnDateTimeChanged;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Clear;
    property DatePicker: TTMSFNCDatePicker read FDatePicker;
    property AnalogTimePicker: TTMSFNCAnalogTimePicker read FAnalogTimePicker;
    property DigitalTimePicker: TTMSFNCDigitalTimePicker read FDigitalTimePicker;
    {$IFDEF FMXLIB}
    property DateEdit: TDateEdit read FDateEdit;
    property TimeEdit: TTimeEdit read FTimeEdit;
    {$ENDIF}
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCDateTimePicker = class(TTMSFNCCustomDateTimePicker)
    property AllowNumericNullValue;
    property Editable;
    property CloseOnSelection;
    {$IFDEF FMXLIB}
    property Native;
    {$ENDIF}
    property TimePickerMode;
    property SelectedDateTime;
    property OnDateTimeChanged;
  end;

implementation

{$IFDEF FMXLIB}
uses
  SysUtils;
{$ENDIF}

type
  TTMSFNCAnalogTimePickerOpen = class(TTMSFNCAnalogTimePicker);
  TTMSFNCDigitalTimePickerOpen = class(TTMSFNCDigitalTimePicker);
  TTMSFNCDatePickerOpen = class(TTMSFNCDatePicker);

{ TTMSFNCCustomDateTimePicker }

procedure TTMSFNCCustomDateTimePicker.ChangeMode(
  AMode: TTMSFNCDateTimePickerMode);
var
  t: TTime;
begin
  if AMode = dtpmAnalog then
  begin
    t := 0;
    if Assigned(FDigitalTimePicker) then
    begin
      t := FDigitalTimePicker.SelectedTime;
      FDigitalTimePicker.Parent := nil;
    end;

    if not Assigned(FAnalogTimePicker) then
      FAnalogTimePicker := TTMSFNCAnalogTimePicker.Create(Self);

    FAnalogTimePicker.Parent := Self;
    {$IFDEF FMXLIB}
    FAnalogTimePicker.Stored := False;
    {$ENDIF}
    FAnalogTimePicker.AdaptToStyle := AdaptToStyle;
    FAnalogTimePicker.Width := Round(Width / 2);
    FAnalogTimePicker.ControlAlignment := caRight;
    FAnalogTimePicker.SelectedTime := t;
    FAnalogTimePicker.Editable := FEditable;
    FAnalogTimePicker.CloseOnSelection := FCloseOnSelection;
    FAnalogTimePicker.OnTimeSelected := @TimeSelected;
  end
  else if AMode = dtpmDigital then
  begin
    t := 0;
    if Assigned(FAnalogTimePicker) then
    begin
      t := FAnalogTimePicker.SelectedTime;
      FAnalogTimePicker.Parent := nil;
    end;

    if not Assigned(FDigitalTimePicker) then
      FDigitalTimePicker := TTMSFNCDigitalTimePicker.Create(Self);

    FDigitalTimePicker.Parent := Self;
    {$IFDEF FMXLIB}
    FDigitalTimePicker.Stored := False;
    {$ENDIF}
    FDigitalTimePicker.AdaptToStyle := AdaptToStyle;
    FDigitalTimePicker.Width := Round(Width / 2);
    FDigitalTimePicker.ControlAlignment := caRight;
    FDigitalTimePicker.SelectedTime := t;
    FDigitalTimePicker.Editable := FEditable;
    FDigitalTimePicker.CloseOnSelection := FCloseOnSelection;
    FDigitalTimePicker.OnTimeSelected := @TimeSelected;
  end;
end;

procedure TTMSFNCCustomDateTimePicker.Clear;
begin
  FDatePicker.Clear;

  if Assigned(FDigitalTimePicker) then
    FDigitalTimePicker.Clear;

  if Assigned(FAnalogTimePicker) then
    FAnalogTimePicker.Clear;

  {$IFDEF FMXLIB}
  if Assigned(FDateEdit) then
    FDateEdit.Date := 0;

  if Assigned(FTimeEdit) then
    FTimeEdit.Time := 0;
  {$ENDIF}
end;

constructor TTMSFNCCustomDateTimePicker.Create(AOwner: TComponent);
begin
  inherited;
  Width := 180;
  Height := 22;
  FEditable := False;
  FCloseOnSelection := True;
  FAllowNumericNullValue := True;
  FTimePickerMode := dtpmDigital;
  Fill.Color := MakeGraphicsColor(169, 169, 169);
  Stroke.Color := MakeGraphicsColor(169, 169, 169);

  FDatePicker := TTMSFNCDatePicker.Create(Self);
  FDatePicker.Parent := Self;
  {$IFDEF FMXLIB}
  FDatePicker.Stored := False;
  {$ENDIF}
  FDatePicker.ControlAlignment := caLeft;
  FDatePicker.Editable := FEditable;

  FDigitalTimePicker := TTMSFNCDigitalTimePicker.Create(Self);
  FDigitalTimePicker.Parent := Self;
  {$IFDEF FMXLIB}
  FDigitalTimePicker.Stored := False;
  {$ENDIF}
  FDigitalTimePicker.ControlAlignment := caRight;
  FDigitalTimePicker.Editable := FEditable;

  FAnalogTimePicker := nil;

  FDatePicker.OnDateSelected := @DateSelected;
  FDigitalTimePicker.OnTimeSelected := @TimeSelected;

  {$IFDEF FMXLIB}
  FNative := False;
  FDateEdit := nil;
  FTimeEdit := nil;
  {$ENDIF}
end;

procedure TTMSFNCCustomDateTimePicker.DateSelected(Sender: TObject;
  ADate: TDate);
begin
  DoDateTimeChanged(SelectedDateTime);
//  if (FTimePickerMode = dtpmDigital) and Assigned(FDigitalTimePicker) then
//  begin
    //SelectedDateTime := ADate + FDigitalTimePicker.SelectedTime;
//    DoDateTimeChanged(SelectedDateTime);
//  end
//  else if (FTimePickerMode = dtpmAnalog) and Assigned(FAnalogTimePicker) then
//  begin
    //SelectedDateTime := ADate + FAnalogTimePicker.SelectedTime;
//    DoDateTimeChanged(SelectedDateTime);
//  end;
end;

destructor TTMSFNCCustomDateTimePicker.Destroy;
begin
  FDatePicker.Free;

  if Assigned(FDigitalTimePicker) then
    FDigitalTimePicker.Free;

  if Assigned(FAnalogTimePicker) then
    FAnalogTimePicker.Free;

  {$IFDEF FMXLIB}
  if Assigned(FDateEdit) then
    FDateEdit.Free;

  if Assigned(FTimeEdit) then
    FTimeEdit.Free;
  {$ENDIF}

  inherited;
end;

procedure TTMSFNCCustomDateTimePicker.DoDateTimeChanged(ADateTime: TDateTime);
begin
  if Assigned(OnDateTimeChanged) then
    OnDateTimeChanged(Self, ADateTime);
end;

function TTMSFNCCustomDateTimePicker.GetSelectedDateTime: TDateTime;
begin
  Result := 0.0;
  if Assigned(FDatePicker) {$IFDEF FMXLIB}and not Native{$ENDIF} then
  begin
    if Assigned(FDigitalTimePicker) then
      Result := FDatePicker.SelectedDate + FDigitalTimePicker.SelectedTime
    else if Assigned(FAnalogTimePicker) then
      Result := FDatePicker.SelectedDate + FAnalogTimePicker.SelectedTime
  end
  {$IFDEF FMXLIB}
  else if Assigned(FDateEdit) and Native then
  begin
    Result := FDateEdit.Date + FTimeEdit.Time;
  end{$ENDIF};
end;

function TTMSFNCCustomDateTimePicker.GetSubComponentArray: TTMSFNCStylesManagerComponentArray;
var
  arr: TTMSFNCStylesManagerComponentArray;
  m: TTMSFNCDateTimePickerMode;
begin
  SetLength(arr, 3);
  if not Assigned(FAnalogTimePicker) then
  begin
    m := TimePickerMode;
    TimePickerMode := dtpmAnalog;
    TimePickerMode := m;
  end;

  arr[0] := FDatePicker;
  arr[1] := FDigitalTimePicker;
  arr[2] := FAnalogTimePicker;

  Result := arr;
end;

function TTMSFNCCustomDateTimePicker.GetVersion: string;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCCustomDateTimePicker.Loaded;
begin
  inherited;
  {$IFDEF VCLLIB}
  {$HINTS OFF}
  {$IF (COMPILERVERSION >= 33)}
  if Assigned(FDigitalTimePicker) then
    TTMSFNCDigitalTimePickerOpen(FDigitalTimePicker).ChangeDPIScale(DesigntimeFormPixelsPerInch, 96);

  if Assigned(FAnalogTimePicker) then
    TTMSFNCAnalogTimePickerOpen(FAnalogTimePicker).ChangeDPIScale(DesigntimeFormPixelsPerInch, 96);

  TTMSFNCDatePickerOpen(FDatePicker).ChangeDPIScale(DesigntimeFormPixelsPerInch, 96);
  {$IFEND}
  {$HINTS ON}
  {$ENDIF}
end;

procedure TTMSFNCCustomDateTimePicker.SetAdaptToStyle(const Value: Boolean);
begin
  inherited;
  if Assigned(FDatePicker) then
    FDatePicker.AdaptToStyle := Value;

  if Assigned(FDigitalTimePicker) then
    FDigitalTimePicker.AdaptToStyle := Value;

  if Assigned(FAnalogTimePicker) then
    FAnalogTimePicker.AdaptToStyle := Value;
end;

procedure TTMSFNCCustomDateTimePicker.SetAllowNumericNullValue(
  const Value: Boolean);
begin
  if FAllowNumericNullValue <> Value then
  begin
    FAllowNumericNullValue := Value;

    if Assigned(FDatePicker) then
      FDatePicker.AllowNumericNullValue := Value;

    if Assigned(FDigitalTimePicker) then
      FDigitalTimePicker.AllowNumericNullValue := Value;

    if Assigned(FAnalogTimePicker) then
      FAnalogTimePicker.AllowNumericNullValue := Value;
  end;
end;

procedure TTMSFNCCustomDateTimePicker.SetCloseOnSelection(const Value: Boolean);
begin
  if FCloseOnSelection <> Value then
  begin
    FCloseOnSelection := Value;

    if Assigned(FDatePicker) then
      FDatePicker.CloseOnSelection := Value;

    if Assigned(FDigitalTimePicker) then
      FDigitalTimePicker.CloseOnSelection := Value;

    if Assigned(FAnalogTimePicker) then
      FAnalogTimePicker.CloseOnSelection := Value;
  end;
end;

procedure TTMSFNCCustomDateTimePicker.SetEditable(const Value: Boolean);
begin
  if FEditable <> Value then
  begin
    FEditable := Value;
    if Assigned(FDatePicker) then
      FDatePicker.Editable := Value;

    if Assigned(FDigitalTimePicker) then
      FDigitalTimePicker.Editable := Value;

    if Assigned(FAnalogTimePicker) then
      FAnalogTimePicker.Editable := Value;
  end;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomDateTimePicker.DateEditChanged(Sender: TObject);
begin
  DoDateTimeChanged(FDateEdit.Date + FTimeEdit.Time);
end;

procedure TTMSFNCCustomDateTimePicker.TimeEditChanged(Sender: TObject);
begin
  DoDateTimeChanged(FDateEdit.Date + FTimeEdit.Time);
end;

procedure TTMSFNCCustomDateTimePicker.SetNative(const Value: Boolean);
var
  d: TDate;
  t: TTime;
begin
  if FNative <> Value then
  begin
    FNative := Value;

    d := Date;
    t := Time;
    if FNative then
    begin
      //Date
      if Assigned(FDatePicker) then
      begin
        d := FDatePicker.SelectedDate;
        FDatePicker.Parent := nil;
      end;

      if not Assigned(FDateEdit) then
        FDateEdit := TDateEdit.Create(Self);

      FDateEdit.Parent := Self;
      FDateEdit.Stored := False;
      FDateEdit.Date := d;
      FDateEdit.Width := Width / 2;
      FDateEdit.Align := TAlignLayout.Left;
      FDateEdit.OnChange := @DateEditChanged;

      //Time
      if Assigned(FAnalogTimePicker) and (TimePickerMode = dtpmAnalog) then
      begin
        t := FAnalogTimePicker.SelectedTime;
        FAnalogTimePicker.Parent := nil;
      end;

      if Assigned(FDigitalTimePicker) and (TimePickerMode = dtpmDigital) then
      begin
        t := FDigitalTimePicker.SelectedTime;
        FDigitalTimePicker.Parent := nil;
      end;

      if not Assigned(FTimeEdit) then
        FTimeEdit := TTimeEdit.Create(Self);

      FTimeEdit.Parent := Self;
      FTimeEdit.Stored := False;
      FTimeEdit.Time := t;
      FTimeEdit.Width := Width / 2;
      FTimeEdit.Align := TAlignLayout.Right;
      FTimeEdit.OnChange := @TimeEditChanged;
    end
    else
    begin
      //Date:
      if Assigned(FDateEdit) then
      begin
        d := FDateEdit.Date;
        FDateEdit.Parent := nil;
      end;

      if not Assigned(FDatePicker) then
        FDatePicker := TTMSFNCDatePicker.Create(Self);

      FDatePicker.Parent := Self;
      FDatePicker.Stored := False;
      FDatePicker.SelectedDate := d;
      FDatePicker.Width := Width / 2;
      FDatePicker.Align := TAlignLayout.Left;
      FDatePicker.OnDateSelected := @DateSelected;

      //Time:
      if Assigned(FTimeEdit) then
      begin
        t := FTimeEdit.Time;
        FTimeEdit.Parent := nil;
      end;

      if TimePickerMode = dtpmAnalog then
      begin
        ChangeMode(dtpmAnalog);
        FAnalogTimePicker.SelectedTime := t;
      end
      else if TimePickerMode = dtpmDigital then
      begin
        ChangeMode(dtpmDigital);
        FDigitalTimePicker.SelectedTime := t;
      end;
    end
  end;
end;

procedure TTMSFNCCustomDateTimePicker.SetEnabled(const Value: Boolean);
{$ENDIF}
{$IFDEF CMNWEBLIB}
procedure TTMSFNCCustomDateTimePicker.SetEnabled(Value: Boolean);
{$ENDIF}
begin
  inherited;
  if Assigned(FDatePicker) then
    FDatePicker.Enabled := Value;

  if Assigned(FDigitalTimePicker) then
    FDigitalTimePicker.Enabled := Value;

  if Assigned(FAnalogTimePicker) then
    FAnalogTimePicker.Enabled := Value;

  {$IFDEF FMXLIB}
  if Assigned(FDateEdit) then
    FDateEdit.Enabled := Value;

  if Assigned(FTimeEdit) then
    FTimeEdit.Enabled := Value;
  {$ENDIF}

  Invalidate;
end;

procedure TTMSFNCCustomDateTimePicker.SetSelectedDateTime(
  const Value: TDateTime);
var
  tpv: TDateTime;
begin
  if Assigned(FDatePicker) then
  begin
    tpv := 0.0;
    FDatePicker.SelectedDate := Int(Value);

    {$IFDEF FMXLIB}
    if Assigned(FDateEdit) then
      FDateEdit.Date := Int(Value);

    if Assigned(FTimeEdit) then
    begin
      tpv := Frac(Value);
      FTimeEdit.Time := Frac(tpv);
    end;
    {$ENDIF}

    if Assigned(FDigitalTimePicker) then
    begin
      tpv := Frac(Value);
      FDigitalTimePicker.SelectedTime := Frac(tpv);
    end;

    if Assigned(FAnalogTimePicker) then
    begin
      tpv := Frac(Value);
      FAnalogTimePicker.SelectedTime := Frac(tpv);
    end;

    if (FDatePicker.SelectedDate + tpv) <> Value then
      DoDateTimeChanged(Value);
  end;
end;

procedure TTMSFNCCustomDateTimePicker.SetTimePickerMode(
  const Value: TTMSFNCDateTimePickerMode);
begin
  if (FTimePickerMode <> Value) {$IFDEF FMXLIB}and not Native{$ENDIF} then
  begin
    FTimePickerMode := Value;
//    if IsDesignTime then
      ChangeMode(Value);
  end;
end;

procedure TTMSFNCCustomDateTimePicker.TimeSelected(Sender: TObject;
  ATime: TTime);
begin
  //SelectedDateTime := FDatePicker.SelectedDate + ATime;
  DoDateTimeChanged(SelectedDateTime);
end;

procedure TTMSFNCCustomDateTimePicker.UpdateControlAfterResize;
begin
  inherited;
  if Assigned(FDatePicker) then
    FDatePicker.Width := Round(Width / 2);

  if Assigned(FDigitalTimePicker) then
    FDigitalTimePicker.Width := Round(Width / 2);

  if Assigned(FAnalogTimePicker) then
    FAnalogTimePicker.Width := Round(Width / 2);

  {$IFDEF FMXLIB}
  if Assigned(FDateEdit) then
    FDateEdit.Width := Width / 2;

  if Assigned(FTimeEdit) then
    FTimeEdit.Width := Width / 2;
  {$ENDIF}
end;

end.
